import Dropdown from "../Dropdown";
import { projectMenus } from "../ProjectMenus";

export default function ProcessMenu(props) {
  return (
    <Dropdown
      menuKey="process"
      menu={projectMenus.process}
      {...props}
    />
  );
}
